import type { DomainSchema, PdfCardDef } from '../types';
import { dateRange, esc, metaJoin } from '../pdf-helpers';

export const PROJECTS = {
  priority: true,
  cardTitle: '{title}',
  fields: {
    title: { type: 'text' },
    description: { type: 'textarea' },
    url: { type: 'text', label: 'URL' },
    startDate: { type: 'date', label: 'Start Date' },
    endDate: { type: 'date', label: 'End Date' },
    associatedWith: { type: 'text', label: 'Associated With' },
  },
  layout: [
    [{ field: 'associatedWith' }],
    [
      { field: 'startDate', width: 50 },
      { field: 'endDate', width: 50 },
    ],
    [{ field: 'url' }],
    [{ field: 'description' }],
  ],
  editLayout: [
    [{ field: 'title' }],
    [{ field: 'associatedWith' }],
    [
      { field: 'startDate', width: 50 },
      { field: 'endDate', width: 50 },
    ],
    [{ field: 'url' }],
    [{ field: 'description' }],
  ],
} satisfies DomainSchema;

export const ProjectsPdfCard: PdfCardDef = {
  styles: `
    .proj-item { padding: 0.75rem 0; border-bottom: 1px solid var(--line); }
    .proj-item:first-child { padding-top: 0; }
    .proj-item:last-child { border-bottom: none; padding-bottom: 0; }
    .proj-title { font-size: 13.5px; font-weight: 700; }
    .proj-assoc { font-size: 12px; color: var(--primary); font-weight: 400; margin-top: 2px; }
    .proj-meta  { font-size: 11px; color: var(--muted); margin-top: 3px; }
  `,
  render(records) {
    return records
      .map(r => {
        const dr = dateRange(r['startDate'], r['endDate'], false);
        const meta = metaJoin([dr || null]);
        return `
          <div class="proj-item">
            <div class="proj-title">${esc(r['title'])}</div>
            ${r['associatedWith'] ? `<div class="proj-assoc">${esc(r['associatedWith'])}</div>` : ''}
            ${meta ? `<div class="proj-meta">${meta}</div>` : ''}
            ${r['description'] ? `<div class="bp-note">${esc(r['description'])}</div>` : ''}
          </div>`;
      })
      .join('');
  },
};
